// extracted by mini-css-extract-plugin
export default {"links":"HeddinLinks_links__05k37","wrapper":"HeddinLinks_wrapper__6qlrE"};